// create api class for /organizations/{id}/custom_bracket_sets

import BaseApiService from './base';

export default class CustomBracketSetsApiService extends BaseApiService {
  constructor() {
    super();
    this.baseEndpointUrl = '/organizations/{id}/custom-bracket-sets';
  }

  get(organizationId, { order, orderBy, userId, perPage, page, ...params }) {
    return this.request({
      method: 'get',
      url: this.baseEndpointUrl.replace('{id}', organizationId),
      params: {
        filter: {
          ...params
        },
        perPage,
        page,
        sort: order === 'desc' ? `-${orderBy || 'name'}` : `${orderBy || 'name'}`
      }
    });
  }

  create(organizationId, data) {
    return this.request({
      method: 'post',
      url: this.baseEndpointUrl.replace('{id}', organizationId),
      data
    });
  }

  update(organizationId, id, data) {
    return this.request({
      method: 'put',
      url: `${this.baseEndpointUrl.replace('{id}', organizationId)}/${id}`,
      data
    });
  }

  delete(organizationId, id) {
    return this.request({
      method: 'delete',
      url: `${this.baseEndpointUrl.replace('{id}', organizationId)}/${id}`
    });
  }
}
